import rp212 from "./rp212";
import rp220 from "./rp220";
import rp221 from "./rp221";

export default {
    rp212,
    rp220,
    rp221
}